import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ChapterApiService} from '../api/chapter-api.service';
import {ToastrService} from 'ngx-toastr';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';

@Component({
    selector: 'app-chapter',

    templateUrl: './chapter.component.html',
    styleUrl: './chapter.component.css'
})
export class ChapterComponent {
    chapterForm: FormGroup;
    chapterCreationError = false;

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private chapterApiService: ChapterApiService,
        private router: Router,
        private spinner: SpinnerService
    ) {
        this.chapterForm = this.fb.group({
            name: ['', [Validators.required]],
            location: ['', [Validators.required]],
            logouri: [''],
            welcomeNote: [''],
        });
    }

    createChapter(): void {
        if (this.chapterForm.valid) {
            this.spinner.show(); // Show spinner while creating chapter
            const chapterData = this.chapterForm.value;
            this.chapterApiService.createChapter(chapterData).pipe(
                finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
            ).subscribe(
                (response) => {
                    console.log('Chapter created successfully', response);
                    this.chapterCreationError = false;
                    // Navigate to chapter list or another appropriate page

                    this.toastr.success(response.name + ' Chapter created successfully!', 'Success');
                },
                (error) => {
                    console.error('Failed to create chapter', error);
                    this.chapterCreationError = true;
                    this.toastr.error('Chapter failed to create.', 'Submission Failed');
                }
            );
        } else {
            this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
        }
    }

    get name() {
        return this.chapterForm.get('name');
    }

    get location() {
        return this.chapterForm.get('location');
    }

    get logouri() {
        return this.chapterForm.get('logouri');
    }

    get welcomeNote() {
        return this.chapterForm.get('welcomeNote');
    }
}